// Main JavaScript file for HarperCollins Leadership website
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel';
import './accessibility.js';
